module.exports = __webpack_public_path__ + "static/img/img03.e7f4469.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c38/img03.png
// module id = mM9Q
// module chunks = 0